import { useLocaleStore, useUserStore } from "@/store";
import { $httpAdmin, $httpAdminSync } from "@package/shared/api/http";
import { URL_ADMIN, URL_ADMIN_EN } from '@package/shared/api/url';
import { type AxiosRequestConfig } from '@package/shared/modules/axios';
import { message } from "@package/shared/util/message";
import { storage } from "@package/shared/util/storage";

export function configureHttp({ adapter }: Partial<AxiosRequestConfig> = {}) {
  if (adapter) $httpAdmin.defaults.adapter = adapter;

  // $httpAdmin.defaults.baseURL = URL_ADMIN;

  $httpAdmin.defaults.timeout = 1000 * 60 * 5;

  $httpAdmin.defaults.validateStatus = function (status) {
    return status < 400;
  };

  $httpAdmin.interceptors.request.use((value) => {
    const user = storage.get<{ username, token; }>('user');
    if (user?.token) value.headers.token = user.token;
    return value;
  });

  $httpAdmin.interceptors.response.use((value) => {
    if (value.data) {
      if (value.data.msg) {
        message.clear().info(value.data.msg);
        if (['过期', '无效'].some(text => value.data.msg.includes(text))) {
          useUserStore().$reset();
        }
      }
    }
    return value;
  }, (err) => {
    if (err?.message) message.clear().error(err.message);
  });

  useLocaleStore().$subscribe((_, { value }) => {
    $httpAdmin.defaults.baseURL = value === 'zh-CN' ? URL_ADMIN : URL_ADMIN_EN;
    $httpAdminSync.defaults.baseURL = value === 'zh-CN' ? URL_ADMIN_EN : URL_ADMIN;
  });

  $httpAdmin.interceptors.request.use((value) => {
    if (value.url?.startsWith('/user')) {
      value.baseURL = URL_ADMIN;
    }
    return value;
  });

  return $httpAdmin;
}
